// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	FirmCard: 'firm-card',
	FileNumber: 'file-number',
} as const;
